import loadMetaTranslations from './load-meta-translations';
import setBuildSlug from './set-build-slug';
import setDesignAutomation from './set-design-automation';
import setEmptyPage from './set-empty-page';
import setMetaTranslations from './set-meta-translations';
import setPageContainerSelector from './set-page-container-selector';
import setPageTemplates from './set-page-templates';
import setPageTemplateHTML from './set-page-template-html';
import setSocialIcons from './set-social-icons';
import setSupportedBlockCategoriesForRegeneration from './set-supported-block-categories-for-regeneration';
import setVariables from './set-variables';

export default {
  loadMetaTranslations,
  setBuildSlug,
  setDesignAutomation,
  setEmptyPage,
  setMetaTranslations,
  setPageContainerSelector,
  setPageTemplates,
  setPageTemplateHTML,
  setSocialIcons,
  setSupportedBlockCategoriesForRegeneration,
  setVariables,
};
